import Vuex from '@/store'
import { ref } from 'vue'
export function getUUID(): string {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
// 根据key值获取当前标签所属的一级菜单,二级菜单
export function getParentSubMenuItemByKey(parentKey: string) {
  // 获取二级菜单
  let selectTabSubmenu: any = {}
  let selectTabMenu: any = {} // 选择的tab所属地一级及二级菜单
  for (const item in Vuex.state.subMenus) {
    for (let i = 0; i < Vuex.state.subMenus[item].length; i++) {
      if (
        Vuex.state.subMenus[item][i].key === parentKey ||
        Vuex.state.subMenus[item][i].parentKey === parentKey
      ) {
        selectTabSubmenu = Vuex.state.subMenus[item]
      }
    }
  }
  // 找到一级菜单
  selectTabMenu = Vuex.state.menus.find((item) => item.key === selectTabSubmenu[0]?.parentKey)
  return {
    selectTabMenu,
    selectTabSubmenu,
  }
}

// 设置选择一级及二级菜单
export function setMenuAndSubmenu(key: string) {
  const menuObj = getParentSubMenuItemByKey(key)
  // 设置选中一级菜单
  Vuex.state.menus.forEach((item: any) => {
    item.isSelect = item.key === menuObj.selectTabMenu.key
  })
  Vuex.commit('set_data', {
    menus: Vuex.state.menus,
    selectMenu: menuObj.selectTabMenu,
    selectSubmenus: menuObj.selectTabSubmenu,
  })
  // 设置二级菜单
  return null
}

export function removeParamAndRefresh(paramName) {
  const url = new URL(window.location.href);
  if (paramName) {
    url.searchParams.delete(paramName);
  }
  window.history.replaceState({}, '', url.href);
  window.location.reload();
}
// 根据后端返回权限，匹配前端展示的菜单

// @params menu 一级菜单
// @params subMenu 二级菜单
export function setMenusAuth(menu: any[], subMenu: any) {
  let userInfo = null
  if (sessionStorage.getItem('__user')) {
    userInfo = JSON.parse(sessionStorage.getItem('__user') + '')
  }
  const menuCodes = userInfo.user.info?.menuCodes || []

  let parentMenu: any[] = []

  // 处理二级菜单
  function handleSubmenu(list: any[]) {
    list.map((item) => {
      item.visible = menuCodes.indexOf(item.key) > 0
      if (item.child && item.child.length >= 0) {
        handleSubmenu(item.child)
      }
    })
  }
  // 处理一级菜单权限
  parentMenu = menu.map((item: any) => {
    item.visible = menuCodes.indexOf(item.key) >= 0
    if (subMenu[item.key]) {
      handleSubmenu(subMenu[item.key])
    }
    return item
  })
  return {
    parentMenu,
    subMenu,
  }
}

let selectTabMenu: any = {
  firstMenu: undefined,
  secondMenu: undefined,
} // 选择的tab所属地一级及二级菜单
// 判断tab是否在二级菜单
function tabIsInSubMenus(url: string, list: any) {
  if (!list) {
    return
  }
  for (let i = 0; i < list.length; i++) {
    if (list[i].url === url) {
      selectTabMenu.secondMenu = list[i]
      break
    } else if (list[i].child && list[i].child.length > 0) {
      tabIsInSubMenus(url, list[i].child)
    }
  }
}

// 判断当前的tab菜单是否在菜单当中，以决定是否做菜单联动，
// 如果在，则拿到parentKey做联动，如果不在，则不作任何处理
// 返回当前tab的菜单
export function tabIsInMenus(url: string) {
  selectTabMenu = {
    firstMenu: undefined,
    secondMenu: undefined,
  }
  for (const item in Vuex.state.menus) {
    if (url === Vuex.state.menus[item].url) {
      selectTabMenu.firstMenu = Vuex.state.menus[item]
      break
    } else {
      tabIsInSubMenus(url, Vuex.state.subMenus[Vuex.state.menus[item].key])
    }
  }
  if (selectTabMenu.secondMenu) {
    for (const item in Vuex.state.menus) {
      if (selectTabMenu.secondMenu.parentKey === Vuex.state.menus[item].key) {
        selectTabMenu.firstMenu = Vuex.state.menus[item]
        break
      }
    }
  }
  return selectTabMenu
}
// 语言包替换
export function $t(key: any, obj = {}) {
  let value = Vuex.state.langPackage[key]
  if (!value) {
    return key
  }
  //eg: $t('common.unit.secondWithNum',[data.duration])
  if (Array.isArray(obj)) {
    let i = -1
    value = value.replace(/\{[a-zA-Z]+\}/g, (_) => {
      i++
      return obj[i] || _
    })
    return value
  }
  //
  for (key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      value = value.replace(`{${key}}`, obj[key])
    }
  }
  return value || key
}

export function formatUrl(prefixKey = 'nfs', url: string) {
  if (!url || url.toLowerCase().indexOf('http') == 0) {
    return url
  }
  const prefix = Vuex.state.config[prefixKey]
  return (prefix + '/' + url).replace(/([^:])\/+/g, '$1/')
}
